import type { TeamSummaryEntry } from "../api/types";

/** Admin only: which client tree the page is showing. */
export function TreePicker({
  roots,
  value,
  onChange,
}: {
  roots: TeamSummaryEntry[];
  value: string;
  onChange: (slug: string) => void;
}): JSX.Element {
  return (
    <label style={{ fontSize: 14, marginRight: 16 }}>
      Client{" "}
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {roots.map((r) => (
          <option key={r.slug} value={r.slug}>
            {r.displayName}
          </option>
        ))}
      </select>
    </label>
  );
}
